module.exports = __webpack_public_path__ + "static/Reduced_Implementation_Time-453f97aa34b30982f18289fa1f6ebe3b.svg";